export default __webpack_public_path__ + "static/media/hms-4.01cf0de4.jpg";